import { render, staticRenderFns } from "./MySecuritiesView.vue?vue&type=template&id=63781fea&scoped=true&"
import script from "./MySecuritiesView.vue?vue&type=script&lang=ts&"
export * from "./MySecuritiesView.vue?vue&type=script&lang=ts&"
import style0 from "./MySecuritiesView.vue?vue&type=style&index=0&id=63781fea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63781fea",
  null
  
)

export default component.exports